import {
    ReceiveHandler,
    ReceiveHandlers,
    ReceiveMessageParams
} from '@/components/C1Opener/OpenerTypes';
import { MessagingChannel } from 'jschannel';

export function receiveMessageFromContainer(
    channel: MessagingChannel,
    handlers: ReceiveHandlers
): void {
    channel.bind('receiveMessageFromContainer', (transaction, data: ReceiveMessageParams) => {
        const notFoundFn: ReceiveHandler = trans =>
            trans.complete?.('Transaction not completed');
        (handlers[data.type] || notFoundFn)(transaction, data);
    });
}